<template>
  <div>
    <v-container grid-list-md>
      <v-layout row
                wrap
                ml-3
                class="form">
        <v-flex sm6>
          <sub-header><template v-slot:title>客戶名稱(要保人)</template>
          </sub-header>
          <v-text-field :value="cusO.cusName" disabled outline/>
        </v-flex>

        <v-flex sm6>
          <sub-header><template v-slot:title>國籍/註冊地</template>
          </sub-header>
          <v-text-field :value="nationalityName(cusO.nationality)" disabled outline/>
        </v-flex>
      </v-layout>

      <v-layout row
                wrap
                ml-3
                class="form">
        <v-flex sm6>
          <sub-header><template v-slot:title>身分證字號/統一編號</template>
          </sub-header>
          <v-text-field :value="cusO.cusIdn" disabled outline/>
        </v-flex>

        <v-flex sm6>
          <sub-header><template v-slot:title>出生/設立日期</template>
          </sub-header>
          <v-text-field :value="cusO.birthday" disabled outline/>
        </v-flex>
      </v-layout>
    </v-container>

    <validation-observer ref="observer">
      <base-box title="一、客戶身分文件檢核">
        <div class="form-box mt-default">

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm7
                        style="padding-left: 20px;">
                  <sub-title-qa>個人戶</sub-title-qa>
                  <sub-title-qa>身分證明文件查核，是否已驗證以下證件確認是否與要保人本人一致?
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="idnCodeAry_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="idnCodeAry.length>0">
                          <input :value="idnCodeAry.join('')"
                              style="height:0;width:0"
                              id="idnCodeAry_chk" />
                        </validation-provider>
                        <v-flex xs12
                                v-for="(item,index) in idnTypeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="idnCodeAry[index+1]"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                            <validation-observer v-slot="{errors}">
                              <validation-provider  :vid="'idnCodeAry_' + item.codeValue + '_' + index"
                                                    v-if="item.codeDesc=='OTHER'"
                                                    :name="item.codeName"
                                                    :rules="(idnCodeAry[index+1] === item.codeValue)?'required':''">
                                <input v-model="annexRisk.idnCodeOther"
                                      v-if="item.codeDesc=='OTHER'"
                                      class="bi-input mt-2 d-in-block"
                                      v-checker
                                      placeholder="輸入文字"
                                      style="max-width:350px;"
                                      maxlength="30"
                                      :disabled="idnCodeAry[index+1] !== item.codeValue"
                                      :id="'idnCodeAry_' + item.codeValue + '_' + index" />
                              </validation-provider>
                            </validation-observer>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
                <v-flex sm5>
                  <b-base-yn v-model="annexRisk.idnCheckYn"
                          v-checker
                          :rules="idnCheckYnRule"
                          vname="是/否"
                          vid="idnCheckYn"
                          :items="toggleInfoItem"></b-base-yn>
                </v-flex>
              </v-layout>
            </v-container>

            <div class="form-box mt-default">
              <v-container grid-list-md
                          class="list-spacer">
                <v-layout row
                          wrap>
                  <v-flex sm9
                          style="padding-left: 20px;">
                    <sub-title-qa>(其他共通項目檢核)有異常者：不得建立業務關係，並應立即申報疑似洗錢或資恐交易。
                    </sub-title-qa>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <v-flex xs12>
                          1.檢視證明文件是否與要保人本人相符，並檢核有無偽、變造情形。 <br>
                          2.檢視客戶是否疑似使用假名、人頭、虛設行號或虛設法人團體投保。<br>
                          3.客戶投保提供之文件資料可疑、模糊不清，不願提供其他佐證資料或提供之文件資料無法進行查證者。<br>
                          4.客戶拒絕提供審核客戶身分措施相關文件。<br>
                          5.對於由代理人辦理投保、保險理賠、保險契約變更或其他交易者，且查證 代理之事實及身分資料有困難。<br>
                          6.出示之身分證明文件均為影本。但依規定得以身分證明文件影本或影像檔，輔以其他管控措施辦理之業務，不在此限。<br>
                          7.客戶不尋常拖延應補充之身分證明文件者。<br>
                          8.客戶或其負責人國籍或註冊地是否為定期更新公告之極高風險國家。<br>
                          9.其他，請說明：
                          <b-text-field
                            v-model="annexRisk.commOther"
                            vname="其他說明"
                            maxlength="30"
                            vid="commOther"
                            outline></b-text-field>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </v-flex>
                  <v-flex sm3>
                    <b-base-yn v-model="annexRisk.commCheckYn"
                            v-checker
                            :rules="commCheckYnRule"
                            vname="正常/異常"
                            vid="commCheckYn"
                            :items="toggleInfoItem1"></b-base-yn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

        </div>
      </base-box>

      <base-box title="二、客戶職行業檢核">
        <div class="form-box mt-default">
          <div class="form-box mt-default">
            <v-container grid-list-md class="list-spacer">
              <v-layout row wrap><!-- fix: SCR #82813 , 客戶職行業檢核補上職業輸入欄位 -->
                <v-flex sm12 style="padding-left: 20px;">
                  <sub-title-qa>職業：</sub-title-qa>
                  <sub-content-qa>
                      <b-auto-or-select v-model="annexRisk.cusJobCode" v-checker
                                        style="width:500px;"
                                        :items="jobsList" s-tag="autocomplete"
                                        item-text="showName"
                                        item-value="careerCode"
                                        :search-input.sync="jobsSync"
                                        :filter="jobsFilter"
                                        label="請選擇"
                                        :rules="jobRuleStr"
                                        vname="職業"
                                        vid="annexRisk_jobCode"
                                        mode="lazy"></b-auto-or-select>
                  </sub-content-qa>
                  <div style="margin-bottom: 20px">
                      <font color='red'>提醒：若非本國銀行職員，僅為證券或期貨員工請選擇006一般金融業</font>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm9
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶是否為以下極高風險行業(不論是否為負責人)：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="riskJobCode_chk"
                                        name=" "
                                        :rules="(annexRisk.riskJobYn === 'Y')?'required':''"
                                        :immediate="riskJobCodeAry.length>0">
                          <input :value="riskJobCodeAry.join('')"
                              style="height:0;width:0"
                              id="riskJobCode_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in careerList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="riskJobCodeAry[index+1]"
                                        v-checker
                                        :disabled="true || (annexRisk.riskJobYn !== 'Y')"
                                        hide-details
                                        :label="item.careerName"
                                        :value="item.careerCode"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
                <v-flex sm3>
                  <b-base-yn v-model="annexRisk.riskJobYn"
                          v-checker
                          :disabled="true"
                          rules="required"
                          vname="是/否"
                          vid="riskJobYn"
                          :items="toggleInfoItem2"></b-base-yn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm9
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶(自然人)是否為以下高風險行業之負責人：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="specJobCode_chk"
                                        name=" "
                                        :rules="(annexRisk.specJobYn === 'Y')?'required':''"
                                        :immediate="specJobCodeAry.length>0">
                          <input :value="specJobCodeAry.join('')"
                              style="height:0;width:0"
                              id="specJobCode_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in career2List"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="specJobCodeAry[index+1]"
                                        v-checker
                                        :disabled="(annexRisk.specJobYn !== 'Y')"
                                        hide-details
                                        :label="item.careerName"
                                        :value="item.careerCode"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
                <v-flex sm3>
                  <b-base-yn v-model="annexRisk.specJobYn"
                          v-checker
                          rules="required"
                          vname="是/否"
                          vid="specJobYn"
                          :items="toggleInfoItem2"></b-base-yn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

        </div>
      </base-box>

      <base-box title="三、疑似洗錢、資恐或資助武擴交易態樣檢核">
        <div class="form-box mt-default">

          <div class="form-box mt-default">

            <div class="form-box mt-default">
              <v-container grid-list-md
                          class="list-spacer">
                <v-layout row
                          wrap>
                  <v-flex sm9
                          style="padding-left: 20px;">
                    <sub-title-qa>任一回答為是者，應立即申報疑似洗錢、資恐或資助武擴交易。
                    </sub-title-qa>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <v-flex xs12>
                          1.客戶繳交大額保費(300萬以上)或短期內密集(三個月三筆以上)投保具高保單/現金價值準備金之保險商品，對於資金來源無法提出合理說明，且與其身分、收入顯不相當，或與其營業性質無關者。<br>
                          2.客戶購買保險商品時，對於保障內容或給付項目完全不關心，抑或對於具高保單價值準備金或具高現金價值或躉繳保費之保險商品，僅關注保單借款、 解約或變更受益人等程序。<br>
                          3.有意購買保險的客戶，對保險公司的投資業績毫不關心，只想知道提早該契約/退保的手續。<br>
                          4.要求將保險給付支付給與保單持有人或指定受益人無明顯關係的第三方。<br>
                          5.客戶利用大量現金、約當現金、高價值商品、或不動產等，或使用無關聯之第三方的資金、資產或信用者。<br>
                          6.客戶繳交大額保費（含跨境支付保費）投保後，短期內申請辦理大額保單借款或終止契約，且無法提出合理說明者。<br>
                          7.客戶具「保險經紀人(含兼營保險經紀業務之銀行)防制洗錢及打擊資恐注意事項範本」、或其他無法完成確認身分相關規定程序之情形者。<br>
                          8.只訂立小額契約(保費50萬元以下)及平時以定期付款方式繳交保費的客戶，突然要求訂立一次付清保費(300萬以上)的大額契約。<br>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </v-flex>
                  <v-flex sm3>
                    <b-base-yn v-model="annexRisk.mlCheckYn"
                            v-checker
                            :rules="mlCheckYnRule"
                            vname="正常/異常"
                            vid="mlCheckYn"
                            :items="toggleInfoItem1"></b-base-yn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

        </div>
      </base-box>

      <base-box title="四、客戶姓名及名稱檢核">
        <div class="form-box mt-default">

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm9
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶及有關對象姓名及名稱檢核
                  </sub-title-qa>
                  <sub-title-qa>(含客戶、負責人、代理人、實質受益人、高階管理人員)
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="nameCheckCode_chk"
                                        name=" "
                                        rules=""
                                        :immediate="nameCheckCodeAry.length>0">
                          <input :value="nameCheckCodeAry.join('')"
                              style="height:0;width:0"
                              id="nameCheckCode_chk" />
                        </validation-provider>
                        <v-flex xs12
                                v-for="(item,index) in nameCheckCodeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="nameCheckCodeAry[index+1]"
                                        :disabled="true"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
                <v-flex sm3>
                  <b-base-yn v-model="annexRisk.nameCheckYn"
                          v-checker
                          :disabled="true"
                          rules="required"
                          vname="正常/異常"
                          vid="nameCheckYn"
                          :items="toggleInfoItem1"></b-base-yn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

        </div>
      </base-box>

      <base-box title="五、客戶進件資料">
        <div class="form-box mt-default">
          <v-container grid-list-md>
            <v-layout row
                      wrap
                      ml-3
                      class="form">
              <v-flex sm6>
                <sub-header><template v-slot:title>3個月內投保件數</template>
                </sub-header>
                <v-text-field :value="annexRisk.insurePieces3m" disabled outline/>
              </v-flex>

              <v-flex sm6>
                <sub-header><template v-slot:title>保險商品</template>
                </sub-header>
                <v-text-field :value="annexRisk.proName" disabled outline/>
              </v-flex>
            </v-layout>

            <v-layout row
                      wrap
                      ml-3
                      class="form">
              <v-flex sm6>
                <sub-header><template v-slot:title>首年保費金額</template>
                </sub-header>
                <v-text-field :value="annexRisk.modePrem" disabled outline/>
              </v-flex>

            </v-layout>
          </v-container>

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶進件業務或服務來源：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="insureSource_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexRisk.insureSource)?true:false">
                          <input :value="annexRisk.insureSource"
                              style="height:0;width:0"
                              id="insureSource_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in insureSourceList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexRisk.insureSource"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶繳付保費來源：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="premSource_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexRisk.premSource)?true:false">
                          <input :value="annexRisk.premSource"
                              style="height:0;width:0"
                              id="premSource_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in premSourceList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexRisk.premSource"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="form-box mt-default" v-if="false">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>客戶解約時間：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="cancelTime_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexRisk.cancelTime)?true:false">
                          <input :value="annexRisk.cancelTime"
                              style="height:0;width:0"
                              id="cancelTime_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in cancelTimeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexRisk.cancelTime"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="form-box mt-default" v-if="false">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>繳付保費人員：
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>

                      <v-layout align-center
                                wrap>
                        <validation-provider vid="payerCode_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexRisk.payerCode)?true:false">
                          <input :value="annexRisk.payerCode"
                              style="height:0;width:0"
                              id="payerCode_chk" />
                        </validation-provider>
                        <v-flex xs4
                                v-for="(item,index) in payerCodeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexRisk.payerCode"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

        </div>
      </base-box>

    </validation-observer>
  </div>
</template>
<script>
import { halfFull, policyChangedChecker } from '@/mixin'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
const {
  mapGetters: commonMapGetters
} = createNamespacedHelpers('common')

export default {
  name: 'risk-disclosure',
  mixins: [halfFull, policyChangedChecker],
  props: {
    transCode: String,
    pnop: String,
    insPol: Object,
    insPoliciesData: Array,
    cusO: Object,
    propAnnexRisk: Object,
    countryList: Array,
    srv12List: Array,
    srv14List: Array,
    isDone: {
      type: Boolean,
      default: false
    },
    polInsureType: String,
    polNum: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      toggleInfoItem: [
        { text: '　　　　是　　　　', value: 'Y' },
        { text: '否；不得建立業務關係', value: 'N' }
      ],
      toggleInfoItem1: [
        { text: '正常', value: 'Y' },
        { text: '異常', value: 'N' }
      ],
      toggleInfoItem2: [
        { text: '是', value: 'Y' },
        { text: '否', value: 'N' }
      ],
      annexRisk: {insureSource: '',premSource: ''},
      annexRiskEmpty: {
        transCode: '', // 要保書序號(行動投保序號)
        idnCheckYn: '', // 身分證明文件查核，是否已驗證以下證件確認是否與要保人本人一致(Y/N)
        idnCode: '', // 身分證明文件代碼(有多個時以半形逗號串連)
        idnCodeOther: '', // 身分證明文件代碼-其他說明
        commCheckYn: '', // 其他共通項目檢核是否有異常(Y/N)
        commOther: '', // 其他共通項目檢核是否有異常-其他
        riskJobYn: '', // 客戶是否為以下高風險行業(不論是否為負責人)(Y/N)
        riskJobCode: '', // 客戶是否為以下高風險行業-行業別代碼
        specJobYn: '', // 客戶是否為以下特定行業之負責人(Y/N)
        specJobCode: '', // 客戶是否為以下特定行業之負責人-項目(有多個時以半形逗號串連)
        mlCheckYn: '', // 是否疑似洗錢、資恐或資助武擴交易(Y/N)
        nameCheckYn: '', // 客戶姓名及名稱檢核(Y/N)
        nameCheckCode: '', // 客戶姓名及名稱檢核-項目(有多個時以半形逗號串連)
        insurePieces3m: '', // 3個月內投保件數
        proName: '', // 主約商品名稱
        modePrem: '', // 首年保費金額
        insureSource: '', // 客戶進件業務或服務來源
        premSource: '', // 客戶繳付保費來源
        cancelTime: '', // 客戶解約時間
        payerCode: '', // 繳付保費人員
        status: '', // 填寫狀態(T:暫存; S:完成)
        cusJobCode: null,
      },
      idnTypeList: [],
      careerList: [],
      career2List: [],
      nameCheckCodeList: [],
      idnCodeAry: [],
      riskJobCodeAry: [],
      specJobCodeAry: [],
      nameCheckCodeAry: [],
      jobsSync: null,
      jobRuleStr: 'required',
      cusOAmlResult : null,
    }
  },
  computed: {
    ...commonMapGetters([
      'jobsList',
    ]),
    managerRoleCode () {
      // 分行經理人角色代碼(ADM_PARMD-S01)
      const insParameters = this.$store.getters['common/systemParam']({
        parameterType: 'ADM',
        toObject: true
      })
      let { parameterValue: managerRoleCode } = insParameters['MANAGER_ROLE_CODE']
      return managerRoleCode
    },
    riskScoreLimit () {
      // 填寫EDD問卷分數(ADM_PARMD-S01)
      const insParameters = this.$store.getters['common/systemParam']({
        parameterType: 'INS',
        toObject: true
      })
      let { parameterValue: limit } = insParameters['RISK_SCORE_LIMIT']
      return limit
    },
    idnCheckYnRule() { //fix: SCR #88479 , 加入卡控限制
      if (this.annexRisk?.idnCheckYn === 'N') {
        return 'showMsg:否，不得建立業務關係'
      } else {
        return 'required'
      }
    },
    commCheckYnRule() { //fix: SCR #88479 , 加入卡控限制
      if (this.annexRisk.commCheckYn === 'N') {
        return 'showMsg:有異常者：不得建立業務關係'
      } else {
        return 'required'
      }
    },
    mlCheckYnRule() { //fix: SCR #88479 , 加入卡控限制
      if (this.annexRisk.mlCheckYn === 'N') {
        return 'showMsg:有異常者，應立即申報疑似洗錢且不得建立業務關係'
      } else {
        return 'required'
      }
    },
  },
  created () {
    this.idnTypeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'IDN_TYPE',
      toObject: false
    })
    this.careerList = this.srv12List
    this.career2List = this.srv14List
    this.nameCheckCodeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'NAME_CHECK_CODE',
      toObject: false
    })
    this.insureSourceList = this.$store.getters['common/admCodeDetail']({
      codeType: 'INSURE_SOURCE',
      toObject: false
    })
    this.premSourceList = this.$store.getters['common/admCodeDetail']({
      codeType: 'PREM_SOURCE',
      toObject: false
    })
    this.cancelTimeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'CANCEL_TIME',
      toObject: false
    })
    this.payerCodeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'PAYER_CODE',
      toObject: false
    })
    this.initCheckCusNameAndIdnCard(this.initData) // fix: SCR #82813 , 加入保經表單一進入後，立即進行 被保險人和法定代理人進行姓名發查檢核
  },
  mounted () {
    if (this.isDone) {
      this.$emit('toNextTab')
    }
  },
  watch: {
    idnCodeAry (v) {
      let hasOther = false
      if (v && v.length > 0) {
        v.forEach(e => {
          if (e === 'F') {
            hasOther = true
          }
        })
      }
      if (!hasOther) {
        this.annexRisk.idnCodeOther = ''
      }
    },
    // 'annexRisk.commCheckYn': {  //fix: SCR #88479, 移除 (其他共通項目檢核)有異常者 清空填寫的判斷
    //   immediate: true,
    //   handler (newVal, oldVal) {
    //     if (newVal !== 'N') {
    //       this.annexRisk.commOther = ''
    //     }
    //   }
    // },
    'annexRisk.cusJobCode': { //fix: SCR #82813 , 『行業別代碼』異動處理連動
      immediate: false,
      handler (newVal, oldVal) {
        if (newVal) {
          this.cusJobCodeSync(newVal)
        }
      }
    },
    'annexRisk.riskJobYn': {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== 'Y') {
          this.riskJobCodeAry = []
          this.annexRisk.riskJobCode = ''
        }
      }
    },
    'annexRisk.specJobYn': {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== 'Y') {
          this.specJobCodeAry = []
          this.annexRisk.specJobCode = ''
        }
      }
    },
    // 'annexRisk.insureSource': {
    //   immediate: true,
    //   handler (newVal, oldVal) {
    //     debugger
    //   }
    // },
    changedFlag (v) {
      if (v) {
        this.$emit('setTabDone', false)
      }
    },
    jobsSync (v) {
      //false 則清空 cusJobCode
      if(v){
      }else{
        this.annexRisk.cusJobCode = null
      }
    },
  },
  methods: {
    ...mapActions([
      'saveInsPoliciesAnnexRisk',
      'fetchLifcApi',
      'delEdd',
      'checkCusNameAndIdnCard'
    ]),
    initData(){
        //fix by SCR #82813 , BUG 修正[二、客戶職行業檢核] 欄位 [職業：] 連動失效問題!
        const annRiskObj = this.propAnnexRisk || this.annexRiskEmpty
        //this.annexRisk = {...this.propAnnexRisk}
        Object.assign(this.annexRisk ,annRiskObj)
        if (this.pnop) {
          this.annexRisk.insurePieces3m = this.pnop
        }

        this.annexRisk.proName = this.insPol.proName
        if (this.insPoliciesData && this.insPoliciesData.length > 0) {
          this.insPoliciesData.forEach(e => {
            if (e.ins_item === 'dis_general_prmm') {
              this.annexRisk.modePrem = e.ins_item_value
            }
          })
        } else {
          this.annexRisk.modePrem = ''
        }
        if (this.annexRisk.idnCode) {
          let ary = this.annexRisk.idnCode.split(',')
          ary.forEach(e => {
            for (let i = 0; i < this.idnTypeList.length; i++) {
              if (this.idnTypeList[i].codeValue === e) {
                this.idnCodeAry[i + 1] = e
              }
            }
          })
        }
        let jobCode = this.cusO.jobCode //要保人職業
        this.annexRisk.riskJobYn = 'N'
        //fix: SCR #82813 , 將要保人職業帶入
        this.annexRisk.cusJobCode = jobCode
        for (let i = 0; i < this.careerList.length; i++) {
          if (this.careerList[i].careerCode === jobCode) {
            this.annexRisk.riskJobYn = 'Y'
            this.annexRisk.riskJobCode = jobCode
          }
        }
        if (this.annexRisk.riskJobCode) {
          let ary = this.annexRisk.riskJobCode.split(',')
          ary.forEach(e => {
            for (let i = 0; i < this.careerList.length; i++) {
              if (this.careerList[i].careerCode === e) {
                this.riskJobCodeAry[i + 1] = e
              }
            }
          })
        }
        if (this.annexRisk.specJobCode) {
          let ary = this.annexRisk.specJobCode.split(',')
          ary.forEach(e => {
            for (let i = 0; i < this.career2List.length; i++) {
              if (this.career2List[i].careerCode === e) {
                this.specJobCodeAry[i + 1] = e
              }
            }
          })
        }
        this.reSetNameCheckCodeList(this.cusOAmlResult)
        // 判斷是否顯示EDD
        if (this.insPol.lifRiskScore && parseInt(this.insPol.lifRiskScore) >= this.riskScoreLimit) {
          let userInfo = this.$store.getters["user/info"]
          if (userInfo.roleCode === this.managerRoleCode) {
            // 內部件EDD請採紙本呈上一層主管簽核後掃瞄上傳風險評級系統
          } else {
            this.$emit('setTab2Show', true)
          }
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.$doValidate('observer')
            //this.jobRuleStr = 'required'
          }, 0)
        })
    },
    errorsHandler (errors) {
      const errorsArray = this.$errorMsgHandler(errors)

      return errorsArray
    },
    nationalityName (v) {
      let name = ''
      let ret = this.countryList.forEach(e => {
        if (e.countryCode === v) {
          name = e.countryName
        }
      })
      return name || v
    },
    doValidate () {
      this.$doValidate('observer')
    },
    done: withDebounce(function () {
      return this.$doValidate('observer').then(isValid => {
        if (isValid) {
          this.annexRisk.idnCode = this.idnCodeAry.filter(item => (item)).join(',')
          this.annexRisk.riskJobCode = this.riskJobCodeAry.filter(item => (item)).join(',')
          this.annexRisk.specJobCode = this.specJobCodeAry.filter(item => (item)).join(',')
          this.annexRisk.nameCheckCode = this.nameCheckCodeAry.filter(item => (item)).join(',')
          this.annexRisk.status = 'S'

          this.annexRisk.cancelTime = '' //Issue #54285，此欄位不再使用
          this.annexRisk.payerCode = '' //Issue #54285，此欄位不再使用

          this.annexRisk.transCode = this.transCode
          this.saveInsPoliciesAnnexRisk(this.annexRisk).then(() => {
            this.$emit('goTop')
            let callApi = !this.isDone
            this.$alert('儲存成功', () => {
              if (callApi) { // 沒有做過，或是修改過(沒有打勾完成)，才打電文，避免重被打電文
                // 打電文決定是否要出現tab2
                let userInfo = this.$store.getters["user/info"]
                this.fetchLifcApi({ transCode: this.transCode }).then(r => {
                  if (!r.data || (r.data.resultCode !== '0001' && r.data.resultCode !== '0125')) {
                    if(r.data.message && r.data.message.trim() !== "") {
                      this.$alert("<font color='red'>【洗錢評估系統串接回覆】訊息代碼：" + r.data.resultCode + "<br>訊息回覆內容：" + r.data.message + "。<br>※請截圖或將訊息代碼告知保經行動投保窗口以轉知IT確認。</font>")
                    } else {
                      this.$alert('系統忙碌中，請稍後再試，如持續發生，請聯絡服務人員')
                    }
                    // this.$alert('系統忙碌中，請稍後再試，如持續發生，請聯絡服務人員')
                  } else if (r.data && r.data.resultCode == '0001' && r.data.message) {
                    // 表示系統異常
                    this.$alert('風險評級系統或連結至主管簽核(公文系統)異常，請暫停執行洗錢評估送單，請先連絡保經窗口(8066)或發信至gis.insurance@kgi.com 請資訊人員查明原因')
                  } else if (r.data && r.data.resultCode === '0125') {
                    this.$alert('因系統批次資料尚未轉入，請稍待３分鐘後再重新填寫', () => {
                      this.$emit('forceClose')
                    })
                  //fix: SCR #89564 , 移除相關處理
                  // } else if (userInfo.roleCode === this.managerRoleCode) {
                  //   this.$changedReset()
                  //   this.$emit('setTabDone', true)
                  //   this.$emit('setTab2Show', false)
                  //   this.delEdd({ transCode: this.transCode })
                  //   if (r.data  && r.data.RiskScore && parseInt(r.data.RiskScore) >= this.riskScoreLimit) {
                  //     this.$alert('內部件EDD請採紙本呈上一層主管簽核後掃瞄上傳風險評級系統', () => {
                  //       this.$emit('toNextTab')
                  //     })
                  //   } else {
                  //     this.$emit('toNextTab')
                  //   }
                  } else if (r.data  && r.data.RiskScore && parseInt(r.data.RiskScore) >= this.riskScoreLimit) {
                    this.$changedReset()
                    this.$emit('setTabDone', true)
                    // this.$alert('高風險客戶需加填EDD問卷!', () => {
                    this.$emit('setTab2Show', true)
                    //   this.$emit('toNextTab')
                    // })
                  }
                  else {
                    this.$changedReset()
                    this.$emit('setTabDone', true)
                    this.$emit('setTab2Show', false)
                    this.delEdd({ transCode: this.transCode })
                    this.$emit('toNextTab')
                  }
                })
              } else {
                this.$emit('toNextTab')
              }
            })

          })
        }
      })

    }),
    tempSave: withDebounce(function () {
      if (!this.changedFlag) {
        // Issue #56603 【行動投保】保經文件『檢查漏勾漏填』完成後，點擊暫存，仍需保留完成的√
        this.$alert('資料無異動')
        return
      }
      this.$emit('setTabDone', false)

      this.annexRisk.idnCode = this.idnCodeAry.filter(item => (item)).join(',')
          this.annexRisk.riskJobCode = this.riskJobCodeAry.filter(item => (item)).join(',')
          this.annexRisk.specJobCode = this.specJobCodeAry.filter(item => (item)).join(',')
          this.annexRisk.nameCheckCode = this.nameCheckCodeAry.filter(item => (item)).join(',')
          this.annexRisk.status = 'T'

          this.annexRisk.transCode = this.transCode
          this.saveInsPoliciesAnnexRisk(this.annexRisk).then(() => {
            this.$alert('暫存成功')
          })
    }),
    cleanAll () {
      let keepRiskJobYn = this.annexRisk.riskJobYn
      let keepRiskJobCode = this.annexRisk.riskJobCode
      let keepNameCheckYn = this.annexRisk.nameCheckYn
      let keepNameCheckCode = this.annexRisk.nameCheckCode

      let keepInsurePieces3m = this.annexRisk.insurePieces3m
      let keepProName = this.annexRisk.proName
      let keepModePrem = this.annexRisk.modePrem
      this.annexRisk = { ...this.$options.data().annexRisk }

      this.annexRisk.riskJobYn = keepRiskJobYn
      this.annexRisk.riskJobCode = keepRiskJobCode
      this.annexRisk.nameCheckYn = keepNameCheckYn
      this.annexRisk.nameCheckCode = keepNameCheckCode
      this.annexRisk.insurePieces3m = keepInsurePieces3m
      this.annexRisk.proName = keepProName
      this.annexRisk.modePrem = keepModePrem

      this.idnCodeAry = []
      // this.riskJobCodeAry = []
      this.specJobCodeAry = []
      // this.nameCheckCodeAry = []

      this.$reset('observer')
      this.$emit('setTabDone', false)
    },
    jobsFilter (item, queryText, itemText) {
      return (
        item.careerCode
          .indexOf(queryText) > -1 ||
        item.careerName
          .indexOf(queryText) > -1
      )
    },
    initCheckCusNameAndIdnCard (callbackFn){ //fix: SCR #82813 , 加入保經表單一進入後，立即進行 被保險人和法定代理人進行姓名發查檢核
        //9. 進入頁面時先對要保人、被保險人和法定代理人進行姓名發查檢核
        this.checkCusNameAndIdnCard({ transCode: this.transCode}).then(r => {
            if (r.data.status === 'E') {// 失敗
              this.$alert(r.data.message).then(() => {
                 //重新導向到查詢列表
                 this.$router.replace({ name: 'proposal' })
              })
            } else if(r.data.status === 'M') {// 複選
              this.$alert(r.data.message).then(() => {
                //fix: SCR #82813 , 觸發呼叫重新讀取
                if(r.data.amlResult){
                  this.reSetNameCheckCodeList(r.data.amlResult)
                }
                //正常進入此功能
                if(callbackFn){
                  callbackFn()
                }
              })
            } else { // 成功
              //正常進入此功能
              if(r.data.message){
                this.$alert(r.data.message).then(() => {
                  //fix: SCR #82813 , 觸發呼叫重新讀取
                  if(r.data.amlResult){
                    this.reSetNameCheckCodeList(r.data.amlResult)
                  }
                  if(callbackFn){
                    callbackFn()
                  }
                })
              }else{
                if(callbackFn){
                  callbackFn()
                }
              }
            }
        })
    },
    cusJobCodeSync(jobCode){
        const {careerList} = this
        let riskJobCodeAry =  this.riskJobCodeAry
        if(careerList){
          if(!riskJobCodeAry){
            riskJobCodeAry = []
            this.riskJobCodeAry = riskJobCodeAry
          }
          let riskJobYn = 'N'
          for (let i = 0; i < careerList.length; i++) {
            if (careerList[i].careerCode === jobCode) {
              riskJobYn = 'Y'
              riskJobCodeAry = []
              this.annexRisk.riskJobCode = jobCode
              riskJobCodeAry[i + 1] = jobCode
              this.riskJobCodeAry = riskJobCodeAry
              break
            }
          }
          this.annexRisk.riskJobYn = riskJobYn
        }
    },
    reSetNameCheckCodeList(amlResult){//fix: SCR #82813 , 觸發重新讀取 cusO.amlResult
      if(amlResult){
      }else{
        //fix: Issue #89793 , 修正第一次進入的 UI 判斷上的 BUG
        if(this.cusO.userCode && this.cusO.amlResult === null){
          this.annexRisk.nameCheckYn = 'Y'
        }else{
          amlResult = this.cusO.amlResult
        }
      }
      this.annexRisk.nameCheckCode = ''
      if (amlResult) {
        let nameCheckYn = 'Y'
        let amlResultary = amlResult.split(',')
        amlResultary.forEach(e => {
          for (let i = 0; i < this.nameCheckCodeList.length; i++) {
            if (this.nameCheckCodeList[i].codeValue === e) {
              nameCheckYn = 'N'
              if (!this.annexRisk.nameCheckCode) {
                this.annexRisk.nameCheckCode = e
              } else {
                this.annexRisk.nameCheckCode += ',' + e
              }
            }
          }
        })
        this.annexRisk.nameCheckYn = nameCheckYn
      }
      this.cusOAmlResult = amlResult // 加上額外紀錄避免反覆被呼叫後，又被初始化initData() 當下清除
      if (this.annexRisk.nameCheckCode) {
        let ary = this.annexRisk.nameCheckCode.split(',')
        ary.forEach(e => {
          for (let i = 0; i < this.nameCheckCodeList.length; i++) {
            if (this.nameCheckCodeList[i].codeValue === e) {
              this.nameCheckCodeAry[i + 1] = e
            }
          }
        })
      }
    },
  }

}
</script>
